import { render, staticRenderFns } from "./create-rfp.vue?vue&type=template&id=45e02cb9&"
import script from "./create-rfp.vue?vue&type=script&lang=js&"
export * from "./create-rfp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports